import { render, staticRenderFns } from "./StudentsNotApproved.vue?vue&type=template&id=c14edde6&"
import script from "./StudentsNotApproved.vue?vue&type=script&lang=js&"
export * from "./StudentsNotApproved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports